<template>
  <div>
    <h1>Privacy Policy</h1>
  </div>
</template>
